<template>
  <div>
    <div class="scratch-wrapper" role="group" aria-label="Mã trúng thưởng">
      <input
        v-for="i in Length"
        :key="i"
        class="scratch-input"
        :disabled="disabled"
        :class="{ 'error': ScratchCodeStatus === 'error' }"
        type="text"
        maxlength="2"
        :value="getScratchChar(i - 1)"
        @focus="onScratchFocus(i - 1, $event)"
        @select="onScratchSelect(i - 1, $event)"
        @click="onScratchClick(i - 1, $event)"
        @input="onScratchInput(i - 1, $event)"
        @keyup="onScratchKeyUp(i - 1, $event)"
        @keydown="onScratchKeyDown(i - 1, $event)"
        @paste="onScratchPaste(i - 1, $event)"
        @compositionstart="onCompositionStart"
        @compositionend="onCompositionEnd(i - 1, $event)"
        :ref="'scratch_' + (i - 1)"
        autocomplete="one-time-code"
        inputmode="latin"
      />
    </div>
    <p v-if="ScratchCodeError" class="error-message">{{ ScratchCodeError }}</p>
  </div>
</template>

<script>
export default {
  name: "Scratch_Input",
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    Length: { type: Number, required: true },
    StartLetterArray: { type: Array, default: () => [] },
  },
  data() {
    return {
      chars: [],
      caretIndex: 0,
      caretPos: 0, /** 0 = đầu, 1 = cuối **/
      hiddenValue: "",
      ScratchCode: this.value,
      ScratchLen: this.Length,
      ScratchCodeError: "",
      ScratchCodeStatus: "",
      isComposing: false, /** Theo dõi trạng thái gõ Unicode **/
      composingIndex: null, /** Lưu index của ô đang gõ Unicode **/
    };
  },
  watch: {
    value(newVal) {
      this.ScratchCode = newVal; /** Đồng bộ prop value với ScratchCode **/
      this.validateScratchCode(); /** Kiểm tra mã mỗi khi value thay đổi **/
    },
    Length(newVal) {
      this.ScratchLen = newVal;
    },
  },
  computed: {
    isValidStart() {
      if (!this.ScratchCode[0]) return true;
      const firstChar = this.convertVietnameseToAscii(this.ScratchCode[0]).toUpperCase();
      if(this.StartLetterArray.length==0) return true;
      return this.StartLetterArray.includes(firstChar[0]); /** Chỉ kiểm tra ký tự đầu sau chuyển đổi **/
    },
  },
  methods: {
    convertVietnameseToAscii(str) {
      /** Map đặc biệt cho các ký tự mở rộng từ bộ gõ Telex **/
      const multiCharMap = {
        'â': 'AA',
        'Â': 'AA',
        'ê': 'EE',
        'Ê': 'EE',
        'ô': 'OO',
        'Ô': 'OO',
        'ơ': 'OW',
        'Ơ': 'OW',
        'ư': 'UW',
        'Ư': 'UW',
        'đ': 'DD',
        'Đ': 'DD',
        'á': 'A',
        'Á': 'A',
        'à': 'A',
        'À': 'A',
        'ả': 'A',
        'Ả': 'A',
        'ã': 'A',
        'Ã': 'A',
        'ạ': 'A',
        'Ạ': 'A',
        /** Thêm ánh xạ khác nếu cần, ví dụ: é → 'E' **/
      };

      const from =
        "àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹ" +
        "ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ";
      const to =
        "AAAAAAAAAAAAAAAAAEEEEEEEEEEEIIIIIIOOOOOOOOOOOOOOOOOOUUUUUUUUUUUYYYY" +
        "AAAAAAAAAAAAAAAAAEEEEEEEEEEEIIIIIIOOOOOOOOOOOOOOOOOOUUUUUUUUUUUYYYY";

      return str.split('').map(char => {
        if (multiCharMap[char]) return multiCharMap[char];
        const index = from.indexOf(char);
        return index >= 0 ? to[index] : char;
      }).join('');
    },
    convertFullCode() {
      const converted = this.convertVietnameseToAscii(this.ScratchCode)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, this.ScratchLen);
      this.ScratchCode = converted;
      this.$emit("input", this.ScratchCode); /** Emit giá trị mới về component cha **/
      /** Cập nhật lại các ô input với giá trị đã chuyển đổi (chữ hoa) **/
      for (let i = 0; i < this.ScratchLen; i++) {
        let ref = this.$refs["scratch_" + i];
        if (Array.isArray(ref)) ref = ref[0];
        if (ref) ref.value = converted.charAt(i) || "";
      }
    },
    getScratchChar(index) {
      return (this.ScratchCode || "").charAt(index) || "";
    },
    focusScratch(index) {
      let ref = this.$refs["scratch_" + index];
      if (Array.isArray(ref)) ref = ref[0];
      if (ref && typeof ref.focus === "function") {
        ref.focus();
        try {
          ref.setSelectionRange && ref.setSelectionRange(0, 1);
        } catch (e) {/**/}
      }
    },
    validateScratchCode() {
      if (this.ScratchCode && !this.isValidStart) {
        this.ScratchCodeError = `Chương trình này Mã chỉ bắt đầu bằng ${this.StartLetterArray.join(" hoặc ")}`;
        this.ScratchCodeStatus = "error";
      } else {
        this.ScratchCodeError = "";
        this.ScratchCodeStatus = "";
      }
      this.$emit("update:status", this.ScratchCodeStatus); /** Emit trạng thái **/
      this.$emit("update:error", this.ScratchCodeError); /** Emit lỗi **/
    },
    onCompositionStart() {
      this.isComposing = true; /** Bắt đầu gõ Unicode **/
    },
    onCompositionEnd(index, e) {
      this.isComposing = false; /** Kết thúc gõ Unicode **/
      this.composingIndex = null;
      /** Kích hoạt lại logic xử lý input ngay sau khi gõ Unicode hoàn tất **/
      this.onScratchInput(index, e);
    },
    onScratchInput(index, e) {
      if (this.isComposing) {
        this.composingIndex = index; /** Lưu index ô đang gõ Unicode **/
        return; /** Chờ hoàn tất gõ Unicode **/
      }

      const val = (e.target.value || "").toUpperCase(); /** Chuẩn hóa thành chữ hoa ngay lập tức **/
      e.target.value = val.charAt(0) || ""; /** Giữ ký tự gốc (Unicode, chữ hoa) trong ô **/

      if (val) {
        const code = this.ScratchCode || "";
        const chars = Array.from({ length: this.ScratchLen }, (_, i) => code.charAt(i) || "");
        chars[index] = val.charAt(0); /** Lưu ký tự gốc (Unicode, chữ hoa) vào ScratchCode **/
        this.ScratchCode = chars.join("");
        this.$emit("input", this.ScratchCode); /** Emit giá trị mới về component cha **/

        /** Chuyển đổi toàn bộ mã nếu đủ độ dài **/
        if (this.ScratchCode.length === this.ScratchLen) {
          this.convertFullCode();
        }

        /** Chuyển focus đến ô tiếp theo nếu chưa đủ mã **/
        if (index < this.ScratchLen - 1) {
          this.$nextTick(() => this.focusScratch(index + 1));
        }
        this.validateScratchCode();
      }
    },
    onScratchFocus(index, e) {
      this.selectedIndex = null;
      this.isUserSelecting = false;
      try {
        const input = e && e.target ? e.target : null;
        if (input) {
          const start = typeof input.selectionStart === "number" ? input.selectionStart : 1;
          const end = typeof input.selectionEnd === "number" ? input.selectionEnd : start;
          const len = Math.max(0, end - start);
          this.lastCaretIndex = index;
          this.lastCaretPos = len > 0 ? 0 : start === 0 ? 0 : 1;
        }
      } catch (e) {/**/}
    },
    onScratchSelect(index, e) {
      try {
        const input = e && e.target ? e.target : null;
        if (!input) return;
        const len = (input.selectionEnd ?? 0) - (input.selectionStart ?? 0);
        this.selectedIndex = len > 0 ? index : null;
        this.isUserSelecting = len > 0;
        this.lastCaretIndex = index;
        this.lastCaretPos = len > 0 ? 0 : input.selectionStart ?? 1;
      } catch (err) {/**/}
    },
    onScratchClick(index, e) {
      try {
        const input = e && e.target ? e.target : null;
        if (input) {
          const start = typeof input.selectionStart === "number" ? input.selectionStart : 1;
          const end = typeof input.selectionEnd === "number" ? input.selectionEnd : start;
          const len = Math.max(0, end - start);
          this.selectedIndex = len > 0 ? index : null;
          this.isUserSelecting = len > 0;
          this.lastCaretIndex = index;
          this.lastCaretPos = len > 0 ? 0 : start === 0 ? 0 : 1;
        }
      } catch (e) {/**/}
    },
    onScratchKeyDown(index, e) {
      const key = e.key;
      if (["Backspace", "ArrowLeft", "ArrowRight"].includes(key)) {
        if (key === "Backspace") {
          e.preventDefault();
          let code = this.ScratchCode || "";
          const chars = code.split("");
          if (chars[index]) {
            chars[index] = "";
            this.ScratchCode = chars.join("").trimEnd();
            this.$emit("input", this.ScratchCode); /** Emit giá trị mới về component cha **/
          } else if (index > 0) {
            const prevRef = this.$refs["scratch_" + (index - 1)];
            this.focusScratch(index - 1);
            const pchars = (this.ScratchCode || "").split("");
            pchars[index - 1] = "";
            this.ScratchCode = pchars.join("").trimEnd();
            this.$emit("input", this.ScratchCode); /** Emit giá trị mới về component cha **/
            if (prevRef && prevRef.value !== undefined) prevRef.value = "";
          }
          this.lastCaretIndex = index;
          this.lastCaretPos = 0;
          this.validateScratchCode();
        } else if (key === "ArrowLeft" && index > 0) {
          e.preventDefault();
          this.focusScratch(index - 1);
          this.lastCaretIndex = index - 1;
          this.lastCaretPos = 0;
        } else if (key === "ArrowRight" && index < this.ScratchLen - 1) {
          e.preventDefault();
          this.focusScratch(index + 1);
          this.lastCaretIndex = index + 1;
          this.lastCaretPos = 1;
        }
        return;
      }
      /** Không chặn ký tự in, chờ xử lý trong onScratchInput sau compositionend **/
    },
    onScratchKeyUp(index, e) {
      if (this.isComposing) return; /** Bỏ qua keyup khi đang gõ Unicode **/
      e.target.value = (e.target.value || "").toUpperCase().charAt(0) || ""; /** Chuẩn hóa chữ hoa trong ô **/
    },
    onScratchPaste(index, e) {
      e.preventDefault();
      const pasted = (e.clipboardData.getData("text") || "").toUpperCase();
      if (!pasted) return;
      const code = this.ScratchCode || "";
      const chars = code.split("");
      for (let i = 0; i < pasted.length && index + i < this.ScratchLen; i++) {
        chars[index + i] = pasted[i];
      }
      if (index + pasted.length < this.ScratchLen) {
        chars[index + pasted.length] = "";
      }
      this.ScratchCode = chars.join("").slice(0, this.ScratchLen);
      this.$emit("input", this.ScratchCode); /** Emit giá trị mới về component cha **/
      const nextIndex = Math.min(index + pasted.length, this.ScratchLen - 1);
      this.$nextTick(() => this.focusScratch(nextIndex));
      /** Chuyển đổi nếu đủ độ dài sau khi dán **/
      if (this.ScratchCode.length === this.ScratchLen) {
        this.convertFullCode();
      }
      this.validateScratchCode();
    },
  },
};
</script>

<style scoped>
.scratch-wrapper {
  display: flex;
  gap: 4px;
  justify-content: center;
}

.scratch-input {
  text-transform: uppercase; /** Hiển thị chữ hoa, kể cả Unicode **/
  text-align: center;
  width: 38px;
  height: 44px;
  font-size: 20px;
  font-weight: bold;
  border: 2px solid #022a1d;
  border-radius: 6px;
  outline: none;
  pointer-events: auto;
  user-select: text;
  -webkit-ime-mode: disabled; /** Vô hiệu hóa bộ gõ tiếng Việt trong WebKit **/
  ime-mode: disabled; /** Vô hiệu hóa bộ gõ tiếng Việt **/
}

.scratch-input:focus {
  box-shadow: 0 0 0 2px rgba(2, 42, 29, 0.2);
}

.scratch-input.error {
  border-color: red;
}

.error-message {
  color: red;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
}
</style>